// extracted by mini-css-extract-plugin
export default {"next_order":"Kw","recurringdis":"Lw","reactivate_button":"Mw","order__summary_title":"Nw","order__summary_items":"Ow","order__summary_item":"Pw","order__summary_item_title":"Qw","order__summary_item_quantity":"Rw","order__item_separator":"Sw","discount":"Tw","promowrapper":"Uw"};
    if(module.hot) {
      // 1715276855845
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  